<template>
  <section v-if="task" class="alert alert-primary d-flex align-items-center justify-content-between gap-3">
    <div>
      <strong>Atendendo à tarefa: {{ task.title }}</strong>
      <div>{{ task.patient?.name }} · {{ typeLabel(task.type) }}</div>
      <small v-if="task.status === 'open'">Ao emitir {{ typeLabel(task.type).toLowerCase() }} neste prontuário, o documento será vinculado a este pedido.</small>
      <small v-else>A tarefa foi respondida ou cancelada. Reabra o pedido antes de vincular outra emissão.</small>
    </div>
    <div class="d-flex gap-2">
      <button class="btn btn-sm btn-primary" type="button" @click="showTask = true">Ver tarefa e responder</button>
      <button class="btn btn-sm btn-light" type="button" @click="leaveTask">Sair da tarefa</button>
    </div>
  </section>
  <TaskModal :open="showTask" :focus-id="task?.id" @close="showTask = false" @changed="load" />
</template>

<script>
import http from '@/helpers/http';
import alert from '@/helpers/alert';
import TaskModal from './TaskModal.vue';
import { taskTypeLabel, taskError } from './taskOptions';

export default {
  components: { TaskModal },
  data: () => ({ task: null, showTask: false }),
  watch: {
    '$route.query.task_id': { immediate: true, handler: 'load' },
  },
  methods: {
    typeLabel: taskTypeLabel,
    async load() {
      this.task = null;
      const { task_id: id, task_place_id: placeId } = this.$route.query;
      if (!id || !placeId) return;
      try {
        const { data } = await http.get(`/places/${placeId}/tasks/${id}`);
        if (String(this.$route.query.task_id) !== String(id)) return;
        this.task = data;
      } catch (error) {
        alert.toastError(taskError(error));
      }
    },
    leaveTask() {
      const query = { ...this.$route.query };
      delete query.task_id;
      delete query.task_type;
      delete query.task_place_id;
      this.$router.replace({ query });
    },
  },
};
</script>
